<template>
  <section class="home-live-container">
    <h2 class="home-title">진행중인 설문</h2>
    <p class="home-sub-title">
      다른 리서처들이 어떤 조건으로 얼마나 빨리 응답을 모으고 있는지 그대로 공개해요.
    </p>

    <div class="home-live-grid">
      <div class="live-card" :class="{ 'live-card--done': item.isDone }" v-for="item in surveyList" :key="item.id">
        <div class="live-card-top">
          <span class="live-card-dday">
            <span v-if="item.isDone">마감</span>
            <span v-else-if="item.dday == 0 && item.dtime >= 0">{{ item.dtime }}시간 남음</span>
            <span v-else-if="item.dday == 0 && item.dtime < 0">0시간 남음</span>
            <span v-else>{{ item.dday }}일 남음</span>
          </span>
          <span class="live-card-author">{{ item.username.substring(0, item.username.length - 1) + "*" }}</span>
        </div>

        <div class="live-card-title">{{ item.title }}</div>

        <div class="live-card-target">
          <span v-if="item.tarInput == null">모두</span>
          <span v-else-if="item.tarInput.length > 20">{{ item.tarInput.substring(0, 20) }}...</span>
          <span v-else>{{ item.tarInput }}</span>
        </div>

        <div class="live-card-progress-row">
          <span class="live-card-count">응답 {{ item.responseCount }} / {{ item.headCount }}명</span>
          <span class="live-card-percent">{{ progressPercent(item) }}%</span>
        </div>
        <div class="live-card-progress-bar">
          <div class="live-card-progress-fill" :style="{ width: progressPercent(item) + '%' }"></div>
        </div>
      </div>

      <p class="home-live-empty" v-if="!loading && surveyList.length === 0">
        아직 진행중인 설문이 없어요.
      </p>
    </div>

    <router-link to="/list" class="home-live-more">진행중인 설문 전체 보기 →</router-link>
  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'HomeLiveSurvey',

  data() {
    return {
      surveyList: [],
      loading: true
    }
  },
  mounted() {
    this.listSurveys()
  },
  methods: {
    async listSurveys() {
      try {
        const response = await axios.get("https://gosurveasy.co.kr/survey/list", {
          params: {
            page: 0,
            size: 3
          }
        })
        this.surveyList = response.data.surveyListVos
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    progressPercent(item) {
      if (!item.headCount) return 0
      return Math.min(100, Math.round((item.responseCount / item.headCount) * 100))
    }
  }
}
</script>

<style scoped>
.home-live-container {
  width: 100%;
  box-sizing: border-box;
  padding: 80px 24px;
  font-family: var(--font-sans);
}

.home-title {
  margin: 0 0 var(--space-3) 0;
  font-size: 34px;
  font-weight: var(--font-weight-bold);
  color: var(--text-heading);
  text-align: left;
}

.home-sub-title {
  margin: 0 0 var(--space-6) 0;
  font-size: 17px;
  font-weight: var(--font-weight-regular);
  color: var(--text-muted);
  text-align: left;
  line-height: 1.6;
}

.home-live-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.live-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-6);
  background-color: var(--surface-card);
  border: 1px solid var(--ink-100);
  border-radius: var(--radius-lg);
  box-sizing: border-box;
  text-align: left;
}

.live-card--done {
  border-color: var(--ink-200);
  background-color: var(--bg-sunken);
}

.live-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.live-card-dday {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: var(--radius-sm);
  background-color: var(--surface-selected);
  color: var(--green-600);
  font-size: 12px;
  font-weight: var(--font-weight-semibold);
}

.live-card--done .live-card-dday {
  background-color: var(--ink-100);
  color: var(--ink-500);
}

.live-card-author {
  font-size: 13px;
  color: var(--text-muted);
}

.live-card-title {
  font-size: 16px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-heading);
}

.live-card-target {
  font-size: 13px;
  color: var(--text-muted);
}

.live-card-progress-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: var(--space-2);
  font-size: 13px;
  font-weight: var(--font-weight-medium);
  color: var(--text-body);
}

.live-card-progress-bar {
  width: 100%;
  height: 6px;
  border-radius: 999px;
  background-color: var(--ink-100);
  overflow: hidden;
}

.live-card-progress-fill {
  height: 100%;
  border-radius: 999px;
  background-color: var(--green-500);
}

.live-card--done .live-card-progress-fill {
  background-color: var(--ink-400);
}

.home-live-empty {
  text-align: center;
  color: var(--text-muted);
  font-size: 14px;
  padding: var(--space-8) 0;
}

.home-live-more {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  margin-top: var(--space-6);
  padding: var(--space-3) var(--space-6);
  border-radius: var(--radius-md);
  border: 1px solid var(--ink-200);
  color: var(--text-heading);
  font-size: 14px;
  font-weight: var(--font-weight-medium);
  text-decoration: none;
}

.home-live-more:hover {
  border-color: var(--green-500);
  color: var(--green-600);
}

@media (max-width: 560px) {
  .home-title {
    font-size: 24px;
  }

  .home-live-grid {
    grid-template-columns: 1fr;
  }
}
</style>
